import { useState, useEffect, useContext } from 'react'
import styles from './styles.module.css'
import { Input, Select } from '../../../components/ModalInputs'
import Button from '../../../components/Button'
import Table from '../../../components/Table'
import { StaffRosterContext } from '../../../utils/context'
import { useSelector } from 'react-redux'

const API_TAB = 'awards'

// Данные для дропдаунов
const awardTypes = [
  { name: '', value: 0 },
  { name: 'Государственная награда', value: 1 },
  { name: 'Ведомственная награда', value: 2 },
  { name: 'Почетная грамота', value: 3 },
  { name: 'Благодарственное письмо', value: 4 },
  { name: 'Почетное звание', value: 5 },
  { name: 'Денежная премия', value: 6 },
  { name: 'Ценный подарок', value: 7 }
]

const awardNames = [
  { name: '', value: '' },
  { name: 'Почетная грамота Министерства образования', value: '1' },
  { name: 'Благодарность Министерства образования', value: '2' },
  { name: 'Почетный работник общего образования РФ', value: '3' },
  { name: 'Заслуженный учитель РФ', value: '4' },
  { name: 'Грамота администрации города', value: '5' },
  { name: 'Благодарность директора', value: '6' },
  { name: 'Премия за высокие результаты', value: '7' },
  { name: 'Медаль «За трудовое отличие»', value: '8' }
]

export default function Award() {
  const { allForms, trackDeletion } = useContext(StaffRosterContext)
  const { values, setFieldValue } = allForms

  // Данные из API (Redux)
  const { personTabData } = useSelector(state => state.personnel)
  const { award: apiAward } = personTabData || {}

  // Локальные состояния для UI
  const [selectedRow, setSelectedRow] = useState(null)
  const [isAddingRow, setIsAddingRow] = useState(false)
  const [newRowData, setNewRowData] = useState({
    name: '',
    docname: '',
    docnum: '',
    docdate: '',
    giver: '',
    level: ''
  })

  // Данные таблицы берем из Formik
  const tableData = values.award || []

  // Синхронизация API данных с Formik (только при первой загрузке)
  useEffect(() => {
    if (apiAward && !tableData.length) {
      setFieldValue('award', apiAward)
    }
  }, [apiAward, tableData.length, setFieldValue])

  const isNewRowComplete = Object.values(newRowData).every(val => val.trim() !== '')

  const handleRowSelect = (id) => {
    setSelectedRow(selectedRow === id ? null : id)
  }

  const handleAddRow = () => {
    setIsAddingRow(true)
    setNewRowData({ name: '', docname: '', docnum: '', docdate: '', giver: '', level: '' })
  }

  const handleNewRowChange = (e) => {
    const { name, value } = e.target
    setNewRowData(prev => ({ ...prev, [name]: value }))
  }

  const handleConfirmAdd = () => {
    const newRow = {
      ...newRowData,
      id: `new_${Date.now()}`
    }
    // Сохраняем в Formik
    setFieldValue('award', [...tableData, newRow])
    setIsAddingRow(false)
    setNewRowData({ name: '', docname: '', docnum: '', docdate: '', giver: '', level: '' })
  }

  const handleCancelAdd = () => {
    setIsAddingRow(false)
    setNewRowData({ name: '', docname: '', docnum: '', docdate: '', giver: '', level: '' })
  }

  const handleDeleteRow = () => {
    if (selectedRow !== null) {
      const rowToDelete = tableData.find(row => (row.id || row.xp_key) === selectedRow)
      if (rowToDelete) {
        const pk = rowToDelete.xp_key || rowToDelete.id || rowToDelete.xp_fm_id
        if (pk && !String(pk).startsWith('new_')) {
          trackDeletion(API_TAB, pk)
        }
      }
      // Обновляем в Formik
      const updatedData = tableData.filter(row => (row.id || row.xp_key) !== selectedRow)
      setFieldValue('award', updatedData)
      setSelectedRow(null)
    }
  }

  const renderOptions = ({ name, value }) => (
    <option key={value || 'empty'} value={value}>{name}</option>
  )

  return (
    <div className={styles.tabWrapper}>
      {/* Таблица */}
      <div className={styles.qualificationTableSection}>
        <Table>
          <thead>
            <tr>
              <th>Название</th>
              <th>Название документа</th>
              <th>Номер документа</th>
              <th>Дата</th>
              <th>Кто вручил</th>
              <th>Уровень</th>
            </tr>
          </thead>
          <tbody>
            {tableData.length > 0 ? (
              tableData.map(row => {
                const rowId = row.id || row.xp_key
                return (
                  <tr
                    key={rowId}
                    onClick={() => handleRowSelect(rowId)}
                    className={selectedRow === rowId ? styles.selectedRow : ''}
                  >
                    <td>{row.name || row.date}</td>
                    <td>{row.docname || row.awardType}</td>
                    <td>{row.docnum || row.awardName}</td>
                    <td>{row.docdate || row.documentNumber}</td>
                    <td>{row.giver || row.documentDate}</td>
                    <td>{row.level}</td>
                  </tr>
                )
              })
            ) : !isAddingRow ? (
              <tr>
                <td colSpan="6" className={styles.emptyTable}>
                  Нет данных о наградах
                </td>
              </tr>
            ) : null}
            {isAddingRow && (
              <tr className={styles.editableRow}>
                <td>
                  <Select name="name" value={newRowData.name} onChange={handleNewRowChange}>
                    {awardNames.map(renderOptions)}
                  </Select>
                </td>
                <td>
                  <Input name="docname" value={newRowData.docname} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input name="docnum" value={newRowData.docnum} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input type="date" name="docdate" value={newRowData.docdate} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Input name="giver" value={newRowData.giver} onChange={handleNewRowChange} />
                </td>
                <td>
                  <Select name="level" value={newRowData.level} onChange={handleNewRowChange}>
                    {awardTypes.map(renderOptions)}
                  </Select>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <div className={styles.qualificationForm}>
        <div className={styles.inputsRow}>
          <div className={styles.qualificationButtonsInline}>
            {!isAddingRow ? (
              <>
                <Button onClick={handleAddRow}>+ Добавить строку</Button>
                <Button mode="delete" onClick={handleDeleteRow}>× Удалить строку</Button>
              </>
            ) : (
              <>
                {isNewRowComplete && (
                  <Button onClick={handleConfirmAdd}>Сохранить</Button>
                )}
                <Button mode="delete" onClick={handleCancelAdd}>Отмена</Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
